export default "__VITE_ASSET__CH5NzzlA__"